<template>
  <RouterView />
  <Toaster position="bottom-center" :duration="4000" close-button rich-colors />
</template>

<script setup lang="ts">
/**
 * v2 Root Shell
 *
 * Minimal root component. Auth initialization is now handled by the router guard
 * (see v2/router/index.ts) which ensures auth is ready before protected routes render.
 *
 * Legacy routes continue to use LegacyAppShell which renders @/App.vue with its own auth logic.
 */
import { provideTopbarActions } from '@v2/layout/composables/useTopbarActions';
import { Toaster } from '@v2/ui/atoms/sonner';
import 'vue-sonner/style.css';
// Provide topbar actions context at root level so all pages can register actions
// before MainLayout mounts (which renders the topbar)
provideTopbarActions();
</script>
